<template>
  <div class="ren-decoration-cp ren-decoration-cp-product-reviews" :style="cardStyle">
    <header>
      <strong>{{ title }}</strong>
      <span v-if="showSummary && summaryText">{{ summaryText }}</span>
    </header>
    <p v-if="reviews.length === 0">暂无评价</p>
    <article v-for="(item, index) in reviews" :key="itemKey(item, index)">
      <strong>{{ reviewer(item) }}</strong>
      <span>{{ reviewContent(item) }}</span>
    </article>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import {
  booleanValue,
  numberValue,
  previewDataRecord,
  previewRecordsFor,
  recordList,
  stringValue
} from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const title = computed(() => stringValue(props.component.props?.title, '商品评价'))
const showSummary = computed(() => booleanValue(props.component.props?.showSummary, true))
const data = computed(() => previewDataRecord(props.componentData))
const summaryText = computed(() => {
  const rate = data.value.goodRate ?? data.value.positiveRate
  return rate == null || rate === '' ? '' : `${rate}% 好评`
})
const reviews = computed(() => {
  const limit = numberValue(props.component.props?.limit, 3)
  const records = previewRecordsFor(
    props.component,
    props.componentData,
    recordList(props.component.props?.items)
  )
  const size = Number.isFinite(limit) && limit > 0 ? Math.min(8, Math.round(limit)) : 3
  return records.slice(0, size)
})
const cardStyle = computed(() => {
  const color = stringValue(props.component.style?.cardColor)
  return color ? { backgroundColor: color } : undefined
})

function reviewer(item: Record<string, unknown>) {
  return stringValue(item.nickname ?? item.userName ?? item.title, '用户')
}

function reviewContent(item: Record<string, unknown>) {
  return stringValue(item.content ?? item.subtitle, '')
}

function itemKey(item: Record<string, unknown>, index: number) {
  return stringValue(item.id, `${reviewer(item)}-${index}`)
}
</script>

<style scoped>
.ren-decoration-cp-product-reviews {
  display: grid;
  gap: 8px;
  padding: 12px;
}

.ren-decoration-cp-product-reviews p,
.ren-decoration-cp-product-reviews span {
  color: var(--ren-theme-muted);
  font-size: 12px;
}

.ren-decoration-cp-product-reviews article {
  display: grid;
  gap: 4px;
}
</style>
